import {
  memo,
  type FC
} from 'react';

export const TournamentTfoot: FC = memo(() => {
  return (
    <tfoot>
      <tr className='call-to-action'>
        <th colSpan={4}>Race to earn your spot</th>
      </tr>
    </tfoot>
  );
});
